"use client";
import { useId } from "react";
import PropTypes from "prop-types";

import { createImageUrl } from "helpers/create-image-url";

import LocationIcon from "assets/svg/location_icon.svg";

import Price from "components/common/price";
import AddFavoriteButton from "components/common/add-favorite-button";
import { LazyImage } from "components/common/lazy-image/LazyImage";
import ShowPhone from "@/src/components/common/show-phone/ShowPhone";

import classNames from "classnames";

import styles from "./styles.module.css";

const VerticalCard = ({
  id,
  media,
  title,
  list,
  location,
  locationSummary,
  price,
  url,
  isSuggestedComponent = false,
  phoneNumber = "",
  onCardClick,
  componentFlag,
  statusCode,
}) => {
  const keyId = useId();
  const mediaUrl = createImageUrl(media, {
    width: isSuggestedComponent ? 510 : 292,
    height: isSuggestedComponent ? 300 : 122,
  });

  const cityName = location?.cityName;
  const districtName = location?.districtName;
  const townName = location?.townName;

  const isConstructionDeal = price?.alternativeValue === "Kat Karşılığı";

  const WrapperClasses = classNames(isSuggestedComponent ? styles.suggestedWrapper : styles.wrapper);

  const mediaWrapClasses = classNames(
    isSuggestedComponent ? [styles.mediaWrapForSuggested, styles.suggestedWrapper] : [styles.mediaWrap, styles.wrapper]
  );

  const locationClasses = classNames(isSuggestedComponent ? styles.locationForSuggested : styles.location);

  const ga4FormattedData = {
    id,
    location: {
      city: { name: cityName },
      district: { name: districtName },
      town: { name: townName },
    },
    priceDetail: {
      price: price?.value,
    },
  };

  const handleClick = (e) => {
    if (isSuggestedComponent) {
      onCardClick();
    }
  };

  return (
    <div className={styles.card}>
      <a
        href={url}
        className={WrapperClasses}
        target={isSuggestedComponent ? "_blank" : "_self"}
        onClick={handleClick}
        title={title}
      >
        <div className={mediaWrapClasses}>
          <LazyImage src={mediaUrl} alt="İlan Kartı" visibleByDefault={isSuggestedComponent} />
        </div>
        <div className={styles.contentWrap}>
          {!isSuggestedComponent && (
            <div className={styles.favoriteIcon}>
              <AddFavoriteButton cityName={cityName} districtName={districtName} townName={townName} listingId={id} />
            </div>
          )}
          <span className={styles.title}>{title}</span>
          {list && (
            <ul className={styles.list}>
              {list.map((item, index) => (
                <li key={`${keyId}-${index}`}>{item.value}</li>
              ))}
            </ul>
          )}
          <div className={locationClasses}>
            <span className={styles.locationIconWrap}>
              <LocationIcon />
            </span>
            {locationSummary}
          </div>
        </div>
        <div className={styles.bottomElements}>
          {price && (
            <span className={styles.priceWrap}>
              {isConstructionDeal ? price.alternativeValue : <Price price={price.value} currency={price.currency} />}
            </span>
          )}
          {isSuggestedComponent && (
            <ShowPhone
              listItemInfo={ga4FormattedData}
              isTextView={true}
              phoneNumber={phoneNumber}
              gtmEventLabel="detay"
              componentFlag={componentFlag}
              statusCode={statusCode}
            />
          )}
        </div>
      </a>
    </div>
  );
};

VerticalCard.propTypes = {
  media: PropTypes.string,
  title: PropTypes.string,
  list: PropTypes.array,
  locationSummary: PropTypes.string,
  location: PropTypes.object,
  price: PropTypes.object,
  url: PropTypes.string,
  id: PropTypes.number,
  isSuggestedComponent: PropTypes.bool,
  phoneNumber: PropTypes.string,
  onCardClick: PropTypes.func,
  componentFlag: PropTypes.string,
  statusCode: PropTypes.bool,
};

export default VerticalCard;
